import React, { FC } from 'react';
import classes from './RatingAbsentMessage.module.scss';

type RatingAbsentMessageProps = {
  textColor: string;
};

export const RatingAbsentMessage: FC<RatingAbsentMessageProps> = ({ textColor }) => (
  <div className={classes.wrap} style={{ color: textColor }}>
    <h1 className={classes.title}>Сотрудник отсутствует</h1>
    <p className={classes.subtitle}>Экран оценки недоступен</p>
  </div>
);
